import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Stack,
  Divider,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { Facebook, LinkedIn, Twitter } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  const footerSections = [
    // {
    //   title: t(StringKeys.PRODUCTS),
    //   links: [
    //     { name: t(StringKeys.PAYMENTS), href: '/#' },
    //     { name: t(StringKeys.BILLING), href: '/#' },
    //     { name: t(StringKeys.INVOICE), href: '/#' },
    //     { name: t(StringKeys.CONNECT), href: '/#' }
    //   ]
    // },
    // {
    //   title: t(StringKeys.RESOURCES),
    //   links: [
    //     { name: t(StringKeys.SUPPORT_CENTER), href: '/support-center' },
    //     { name: t(StringKeys.GUIDES), href: '/#' },
    //     { name: t(StringKeys.DOCUMENTATION), href: '/#' },
    //   ]
    // },
    {
      title: t(StringKeys.LEGAL),
      links: [
        { name: t(StringKeys.PRIVACY_POLICY), href: '/privacy-policy' },
        { name: t(StringKeys.TERMS_OF_SERVICE), href: '/terms-of-service' },
        { name: t(StringKeys.COOKIE_POLICY), href: '/cookie-policy' },
        { name: t(StringKeys.PRIVACY_CHOICES), href: '/privacy-choices' },
        { name: t(StringKeys.PROHIBITED_BUSINESSES), href: '/prohibited-businesses' }
      ]
    },
    {
      title: t(StringKeys.COMPANY),
      links: [
        { name: t(StringKeys.ABOUT), href: '/about' },
        // { name: t(StringKeys.BLOG), href: '/#' },
      ]
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        py: 6,
        borderTop: 1,
        borderColor: 'divider'
      }}
    >
      <Container maxWidth="lg">
        {/* Main footer content */}
        <Grid container spacing={4} mb={6}>
          {footerSections.map((section) => (
            <Grid item xs={12} sm={6} md={3} key={section.title}>
              <Typography
                variant="subtitle1"
                color="text.primary"
                gutterBottom
                fontWeight="medium"
              >
                {section.title}
              </Typography>
              <Stack spacing={1}>
                {section.links.map((link) => (
                  <Link
                    key={link.name}
                    href={link.href}
                    variant="body2"
                    color="text.secondary"
                    underline="hover"
                    sx={{
                      '&:hover': {
                        color: 'primary.main',
                      },
                    }}
                  >
                    {link.name}
                  </Link>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* Bottom bar */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: isMobile ? 'center' : 'flex-start',
            gap: 2
          }}
        >
          {/* Logo and copyright */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="h6" color="text.primary">
              BiziSmart
            </Typography>
            <Typography variant="body2" color="text.secondary">
               {currentYear} BiziSmart, Inc.
            </Typography>
          </Box>

          {/* Social links */}
          <Stack
            direction="row"
            spacing={3}
            sx={{
              alignItems: 'center',
              justifyContent: isMobile ? 'center' : 'flex-end',
            }}
          >
            {[
              {social: t(StringKeys.TWITTER), icon: <Twitter/>, link: '#'},
              {social: t(StringKeys.LINKEDIN), icon: <LinkedIn/>, link: '#'},
              {social: t(StringKeys.FACEBOOK), icon: <Facebook/>, link: 'https://www.facebook.com/people/BiziSmart/61571026855498/'}
            ].map((item) => (
              <Link
                key={item.social}
                href={item.link}
                color="text.secondary"
                underline="hover"
                sx={{
                  '&:hover': {
                    color: 'primary.main',
                  },
                }}
              >
                {item.icon} {item.social}
              </Link>
            ))}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
